import api from './api';

export const bannerService = {
  getAllBanners: () => api.get('/banners'),
  getActiveBanners: () => api.get('/banners/active'),
  getBannerById: (id) => api.get(`/banners/${id}`),
  createBanner: (data) => {
    if (data instanceof FormData) {
      return api.post('/banners', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return api.post('/banners', data);
  },
  updateBanner: (id, data) => {
    if (data instanceof FormData) {
      return api.put(`/banners/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return api.put(`/banners/${id}`, data);
  },
  deleteBanner: (id) => api.delete(`/banners/${id}`),
  reorderBanner: (id, order) => api.put(`/banners/${id}/order`, { order, order_position: order, orderPosition: order }),
};
